import React, { useState, useEffect } from 'react';
import { FaseGrupoPartidasLite } from '../../../../services/faseGrupoPartidasService';
import { atualizarFaseGrupoPartidas } from '../../../../services/faseGrupoPartidasService';

interface EditGroupModalProps {
  grupo: FaseGrupoPartidasLite;
  faseCategoriaTorneioId: string;
  onClose: () => void;
  onSuccess: () => void;
}

const EditGroupModal: React.FC<EditGroupModalProps> = ({
  grupo,
  faseCategoriaTorneioId,
  onClose,
  onSuccess,
}) => {
  const [nome, setNome] = useState(grupo.nome || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    document.body.classList.add('modal-open');
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('modal-open');
    };
  }, [onClose]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim()) {
      alert('Nome do grupo é obrigatório');
      return;
    }

    setSaving(true);
    try {
      await atualizarFaseGrupoPartidas(grupo.id, {
        nome: nome.trim(),
        faseCategoriaTorneioId,
      });
      onSuccess();
    } catch (error) {
      alert('Erro ao atualizar grupo');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  const handleBackdrop = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose} />
      <div
        className="modal fade show d-block"
        role="dialog"
        tabIndex={-1}
        onMouseDown={handleBackdrop}
      >
        <div className="modal-dialog" role="document" onMouseDown={(e) => e.stopPropagation()}>
          <form className="modal-content" onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Editar Grupo</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Fechar"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Nome do Grupo</label>
                <input
                  type="text"
                  className="form-control"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  required
                  autoFocus
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={saving}
              >
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditGroupModal;

